import { EuiBadge } from "@elastic/eui";

interface BadgeProps {
  color?: string;
  iconType?: any;
  iconSide?: "left" | "right" | undefined;
  style?: any;
  text?: string | any;
  className?: string | undefined;
}

const Badge = ({ text, color, iconType, iconSide, style, className }: BadgeProps) => {
  return (
    <span>
      <EuiBadge
        title={undefined}
        className={className}
        color={color}
        iconType={iconType}
        iconSide={iconSide}
        style={style}>
        <span style={{ paddingLeft: iconType ? "4px" : "0px" }}>{text}</span>
      </EuiBadge>
    </span>
  );
};

export default Badge;
